<template>
  <section class="content white flex-grow">
    <table-uferdige-kontrakt :limit="50" :large="true" :brukerId="brukerId"/>
  </section>
</template>

<script>
import TableUferdigeKontrakt from './TableUferdigeKontrakt'

export default {
  name: 'PageUferdigeKontrakt',
  components: {
    TableUferdigeKontrakt
  },
  props: {
    brukerId: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/PageUferdigeKontrakt.vue